import { LoadingOutlined } from '@ant-design/icons';
import { Typography } from 'antd';
import { COLOR_OPTIONS } from 'config/style';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  height: calc(100vh - 150px);
`;

export const LoadingText = styled(Typography.Text)`
  color: ${COLOR_OPTIONS.NEUTRAL_100};
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.12px;
`;

export const StyledLoadingIcon = styled(LoadingOutlined)`
  font-size: 58px;
  color: ${COLOR_OPTIONS.GREEN_60};
`;
